"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _airbnbPropTypes = _interopRequireDefault(require("airbnb-prop-types"));
var _Pressable = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Pressable"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _utils = require("../utils");
var _ListItemBase = _interopRequireDefault(require("./ListItemBase"));
var _ListItemContent = _interopRequireDefault(require("./ListItemContent"));
var _ListItemMark = _interopRequireDefault(require("./ListItemMark"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const selectPressableStyles = _ref => {
  let {
    backgroundColor,
    itemFontColor,
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom,
    interItemMargin
  } = _ref;
  return {
    backgroundColor,
    itemFontColor,
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom,
    marginBottom: interItemMargin,
    ..._Platform.default.select({
      web: {
        outline: 'none'
      }
    })
  };
};
const PressableListItemBase = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    href,
    tokens,
    icon,
    children,
    listItemRef,
    ...rest
  } = _ref2;
  const {
    onPress,
    ...props
  } = _utils.clickProps.toPressProps(rest);
  const {
    hrefAttrs,
    rest: listItemProps
  } = _utils.hrefAttrsProp.bundle(props);
  const handlePress = _utils.linkProps.handleHref({
    href,
    onPress
  });
  const listItemTokens = (0, _utils.selectTokens)('List', typeof tokens === 'function' ? tokens() : tokens);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemBase.default, {
    ref: listItemRef,
    tokens: listItemTokens,
    ...listItemProps,
    children: _ref3 => {
      let {
        isLastItem
      } = _ref3;
      const getTokens = pressableState => (0, _utils.resolvePressableTokens)(tokens, pressableState, {
        last: isLastItem
      });
      const getPressableStyle = pressableState => [staticStyles.itemContainer, selectPressableStyles(getTokens(pressableState))];
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Pressable.default, {
        onPress: handlePress,
        href: href,
        hrefAttrs: hrefAttrs,
        style: getPressableStyle,
        ref: ref,
        children: pressableState => {
          const themeTokens = getTokens(pressableState);
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemMark.default, {
              icon: icon,
              tokens: themeTokens
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemContent.default, {
              tokens: themeTokens,
              children: typeof children === 'function' ? children(pressableState) : children
            })]
          });
        }
      });
    }
  });
});
PressableListItemBase.displayName = 'PressableListItemBase';
const staticStyles = _StyleSheet.default.create({
  itemContainer: {
    flexDirection: 'row',
    flex: 1
  }
});
PressableListItemBase.propTypes = {
  ..._utils.withLinkRouter.propTypes,
  href: _propTypes.default.string,
  onPress: _propTypes.default.func,
  // eslint-disable-next-line react/forbid-prop-types
  tokens: _propTypes.default.any,
  icon: _propTypes.default.elementType,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  listItemRef: _airbnbPropTypes.default.ref()
};
var _default = exports.default = (0, _utils.withLinkRouter)(PressableListItemBase);